<template>
  <div class="FundoLight" :style="CoresLightning">
      <div class="poligonoRaio1"></div>
      <div class="poligonoRaio2"></div>
  </div>
</template>

<script>
export default {
    name: "Lightning",
		data() {
			return {
                backgroundLightning: "#000",
                CorLightning: "#008fac"
            };
		},
	components: {},
    props: ["configLightning"],
	computed: {
		CoresLightning: function () {
			return [
                {"--Lightning-background-color": this.backgroundLightning},
                {"--Lightning-color": this.CorLightning}
            ];
		}
    },
    methods: {
        setConfiguracaoInicial() {
            if(this.configLightning) {
                if (this.configLightning.backgroundLightning) {
					this.backgroundLightning = this.configLightning.backgroundLightning;
				}
				if (this.configLightning.CorLightning) {
					this.CorLightning = this.configLightning.CorLightning
				}
            }
        }
    },
    created() {
            this.setConfiguracaoInicial();
    }
};
</script>

<style>
.FundoLight {
    position: relative;
    width: 100%;
    height: 100%;
    background-color: var(--Lightning-background-color);
    margin: auto;
}

.poligonoRaio1 {
    position: absolute;
    top: 0%;
    left: 0%;
    -webkit-clip-path:polygon(70% 2%, 70% 2%, 47% 55%, 20% 60%);
    clip-path:polygon(70% 2%, 70% 2%, 47% 55%, 20% 60%);
    background: var(--Lightning-color);
    width:100%;
    height:100%;
}

.poligonoRaio2 {
    position: absolute;
    top: 0%;
    left: 0%;
    -webkit-clip-path:polygon(30% 98%, 30% 98%, 53% 40%, 80% 35%);
    clip-path:polygon(30% 98%, 30% 98%, 53% 40%, 80% 35%);
    background: var(--Lightning-color);
    width:100%;
    height:100%;
}
</style>